/* eslint-disable radix */
/* eslint-disable */
// import libs
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import custom components
import EcgLoader from 'legacy/containers/EcgLoader';
import store from 'state/appStore';
import history from '../../../legacy/containers/History';
import IDTFRecordingInfoPane from '../../components/IDTFRecordingInfoPane';
import ConfirmPanel from '../../components/Common/ConfirmPanel';
import ROUTE_PATHS from '../../../routes/routePaths';
// import constants
import { CONFIRM_POPOVER_MSGS } from '../../constsnts/confirmMessages';

// import actions
import { confirmEcg } from '../../state/kardiaRxIdtf/KardiaRxIDTFEcgConfirmActions';

// import css
import styles from './IDTFRecordingReviewPane.css';

const IDTFRecordingReviewPane = props => {
  const { selectedRecordingId, patientId, templateId } = props;
  const me = useSelector(state => state.app.dataSources.me);
  const IDTFEcgConfirm = useSelector(state => state.kardiaRx.IDTFEcgConfirm);
  const dispatch = useDispatch();

  const onConfirmation = () => {
    const {
      participantId,
      idtf_connection_id,
    } = store.getState().kardiaRx.kardiaRxIDTFEcg.selectedPatinet;
    dispatch(confirmEcg(selectedRecordingId));
    // templateId changed to idtf_connection_id
    history.push(
      `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/${participantId}?referral=kardiaRxEcg&idtf_connection_id=${idtf_connection_id}`,
    );
  };

  // const routeChange = () => getState => {
  //   const {
  //     participantId,
  //     connectionTemplateID,
  //   } = getState().kardiaRxIDTFEcg.selectedPatient;
  //   console.log('jjjjjj')
  //   history.push(
  //     `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/${participantId}?referral=kardiaRxEcg&templateID=${connectionTemplateID}`,
  //   );
  // };
  return (
    <div>
      <IDTFRecordingInfoPane
        selectedRecordingId={selectedRecordingId}
        match={props.match}
        patientId={patientId}
        templateId={templateId}
      />
      <div className={styles.confirmPanelWrapper}>
        {IDTFEcgConfirm.isRequesting ? (
          <EcgLoader />
        ) : (
          <ConfirmPanel
            me={me}
            onConfirmation={onConfirmation}
            confirmPopoverMsg={CONFIRM_POPOVER_MSGS.IDTF_RECORDING_CONFIRM}
          />
        )}
      </div>
    </div>
  );
};

export default IDTFRecordingReviewPane;



// WEBPACK FOOTER //
// ./src/views/containers/IDTFRecordingReviewPane/IDTFRecordingReviewPane.jsx